"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postShoplandingPayment = exports.postSubmitVoucher = exports.postSaferpayAlias = exports.postSubmitOrder = exports.postPaymentProviderInput = exports.postPayment = exports.postOrderPaidByVoucher = exports.postSaferpayToken = exports.postSaferpayAlt = exports.getSaferpayAltStatus = exports.getNamedDayDeliveryDates = exports.postPaymentOptionId = exports.getPaymentInfo = exports.postClickAndCollectStoreId = exports.getStoresForGeoLocation = exports.postPickupPoint = exports.getPickupPoints = exports.postDelivery = exports.postDeliveryOption = exports.getDeliveryInfo = exports.postDeliveryCountry = exports.getDeliveryCountries = exports.initRequest = exports.CheckoutVersion = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const common_types_1 = require("@as-react/common-types");
const common_utils_1 = require("@as-react/common-utils");
const createUrl_1 = require("../../utils/createUrl");
var CheckoutVersion;
(function (CheckoutVersion) {
    CheckoutVersion[CheckoutVersion["OLD"] = 1] = "OLD";
    CheckoutVersion[CheckoutVersion["NEW"] = 2] = "NEW";
})(CheckoutVersion || (exports.CheckoutVersion = CheckoutVersion = {}));
const checkoutEndpoints = {
    initiate: { client: 'api/checkout/initiate' },
    contact: { client: 'api/checkout/contact' },
    dtmCheckoutStep: { client: 'api/dtm/checkoutstep' },
    getDeliveryCountries: { client: 'api/deliverycharges/countries/{mainWebshop}/{shopId}' },
    postDeliveryCountry: { client: 'api/buy/delivery/country/{countryId}' },
    getDeliveryInfo: { client: 'api/buy/delivery' },
    postDeliveryOption: { client: 'api/buy/delivery/option/{deliveryOption}' },
    postDelivery: { client: 'api/buy/delivery' },
    getPickupPoints: { client: 'api/pickup/postcode' },
    postPickupPoint: { client: 'api/buy/pickup/v2' },
    collectInStore: { client: 'api/buy/delivery/clickandcollect' },
    getPaymentInfo: { client: 'api/buy/payment' },
    namedDayDeliveryDates: { client: 'api/nameddaydelivery/deliverydays' },
    postPaymentOptionId: { client: 'api/buy/payment/option/{optionId}' },
    getSaferpayAltStatus: { client: 'api/buy/status/saferpay/alternative' },
    postSaferpayAlt: { client: 'api/buy/input/saferpay/alternative' },
    postSaferpayToken: { client: 'api/buy/input/saferpay/token' },
    postShoplandingPayment: { client: 'api/buy/landing' },
    postOrderPaidByVoucher: { client: 'api/buy/payment/voucher' },
    postPayment: { client: 'api/buy/payment/v2' },
    postPaymentProviderInput: { client: 'api/buy/input/{provider}' },
    postSubmitOrder: { client: 'api/buy/submit/{provider}' },
    postSaferpayAlias: { client: 'api/buy/input/saferpay/alias' },
    postSubmitVoucher: { client: 'api/checkout/voucher' },
};
const initRequest = (_a) => tslib_1.__awaiter(void 0, [_a], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams, }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.initiate, isServer);
    const axiosConfig = {
        method: 'POST',
        url,
        params: Object.assign(Object.assign({}, defaultRequestParams), { checkoutVersion: CheckoutVersion.NEW }),
        withCredentials: true,
        data: {
            adobeUuid: common_utils_1.CookieUtil.get(common_types_1.Cookie._UUID),
            visitorId: common_utils_1.CookieUtil.getByRegexp(/^AMCV_.+AdobeOrg/i),
            userAgent: navigator.userAgent,
            fredhopperSegment: common_utils_1.CookieUtil.get(common_types_1.Cookie.FREDHOPPER_SEGMENT),
            consentSetting: common_utils_1.CookieUtil.get(common_types_1.Cookie.CONSENT_SETTING),
        },
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.initRequest = initRequest;
const getDeliveryCountries = (_a) => tslib_1.__awaiter(void 0, [_a], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams, }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.getDeliveryCountries, isServer, {
        mainWebshop: defaultRequestParams.mainWebshop,
        shopId: defaultRequestParams.shopId,
    });
    const axiosConfig = {
        method: 'GET',
        url,
        params: defaultRequestParams,
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getDeliveryCountries = getDeliveryCountries;
const postDeliveryCountry = (_a, countryId_1) => tslib_1.__awaiter(void 0, [_a, countryId_1], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, countryId) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.postDeliveryCountry, isServer, {
        countryId,
    });
    const axiosConfig = {
        method: 'POST',
        url,
        params: defaultRequestParams,
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.postDeliveryCountry = postDeliveryCountry;
const getDeliveryInfo = (_a, countryId_1) => tslib_1.__awaiter(void 0, [_a, countryId_1], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, countryId) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.getDeliveryInfo, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        params: Object.assign(Object.assign({}, defaultRequestParams), { countryId }),
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getDeliveryInfo = getDeliveryInfo;
const postDeliveryOption = (_a, deliveryOption_1) => tslib_1.__awaiter(void 0, [_a, deliveryOption_1], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, deliveryOption) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.postDeliveryOption, isServer, {
        deliveryOption,
    });
    const axiosConfig = {
        method: 'POST',
        url,
        params: defaultRequestParams,
        withCredentials: true,
    };
    yield axios_1.default.request(axiosConfig);
});
exports.postDeliveryOption = postDeliveryOption;
const postDelivery = (_a, deliveryInfo_1) => tslib_1.__awaiter(void 0, [_a, deliveryInfo_1], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, deliveryInfo) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.postDelivery, isServer);
    const axiosConfig = {
        method: 'POST',
        url,
        params: defaultRequestParams,
        withCredentials: true,
        data: deliveryInfo,
    };
    yield axios_1.default.request(axiosConfig);
});
exports.postDelivery = postDelivery;
const getPickupPoints = (_a, _b) => tslib_1.__awaiter(void 0, [_a, _b], void 0, function* ({ servicesEndpoint, isServer }, { postcode, provider, countryCode, deliveryDate, limit }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.getPickupPoints, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        params: { postcode, provider, countryCode, deliveryDate, limit },
        withCredentials: true,
    };
    return yield axios_1.default.request(axiosConfig);
});
exports.getPickupPoints = getPickupPoints;
const postPickupPoint = (_a, _b) => tslib_1.__awaiter(void 0, [_a, _b], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { pickupPoint, provider, countryCode }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.postPickupPoint, isServer);
    const axiosConfig = {
        method: 'POST',
        url,
        params: Object.assign(Object.assign({}, defaultRequestParams), { provider }),
        data: Object.assign(Object.assign({}, pickupPoint), { countryCode }),
        withCredentials: true,
    };
    return yield axios_1.default.request(axiosConfig);
});
exports.postPickupPoint = postPickupPoint;
const getStoresForGeoLocation = (_a, _b_1) => tslib_1.__awaiter(void 0, [_a, _b_1], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, _b) {
    var { fasciaFirst = false } = _b, params = tslib_1.__rest(_b, ["fasciaFirst"]);
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.collectInStore, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        params: Object.assign(Object.assign(Object.assign({}, defaultRequestParams), params), { fasciaFirst }),
        withCredentials: true,
    };
    const answer = yield axios_1.default.request(axiosConfig);
    return answer.data;
});
exports.getStoresForGeoLocation = getStoresForGeoLocation;
const postClickAndCollectStoreId = (_a, storeId_1) => tslib_1.__awaiter(void 0, [_a, storeId_1], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, storeId) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.collectInStore, isServer);
    common_utils_1.CookieUtil.set(common_types_1.Cookie.CLICK_AND_COLLECT_STORE, storeId.toString(), { secure: true });
    const axiosConfig = {
        method: 'POST',
        url,
        params: Object.assign(Object.assign({}, defaultRequestParams), { storeId }),
        withCredentials: true,
    };
    return axios_1.default.request(axiosConfig);
});
exports.postClickAndCollectStoreId = postClickAndCollectStoreId;
const getPaymentInfo = (_a) => tslib_1.__awaiter(void 0, [_a], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams, }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.getPaymentInfo, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        params: defaultRequestParams,
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getPaymentInfo = getPaymentInfo;
const postPaymentOptionId = (_a, optionId_1) => tslib_1.__awaiter(void 0, [_a, optionId_1], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, optionId) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.postPaymentOptionId, isServer, {
        optionId,
    });
    const axiosConfig = {
        method: 'POST',
        url,
        params: defaultRequestParams,
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.postPaymentOptionId = postPaymentOptionId;
const getNamedDayDeliveryDates = (_a) => tslib_1.__awaiter(void 0, [_a], void 0, function* ({ servicesEndpoint, defaultRequestParams, }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.namedDayDeliveryDates);
    const axiosConfig = {
        method: 'GET',
        url,
        params: Object.assign({}, defaultRequestParams),
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getNamedDayDeliveryDates = getNamedDayDeliveryDates;
const getSaferpayAltStatus = (_a, requestId_1) => tslib_1.__awaiter(void 0, [_a, requestId_1], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, requestId) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.getSaferpayAltStatus, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        params: Object.assign(Object.assign({}, defaultRequestParams), { requestId, checkoutVersion: CheckoutVersion.NEW }),
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getSaferpayAltStatus = getSaferpayAltStatus;
const postSaferpayAlt = (_a) => tslib_1.__awaiter(void 0, [_a], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams, }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.postSaferpayAlt, isServer);
    const axiosConfig = {
        method: 'POST',
        url,
        params: Object.assign(Object.assign({}, defaultRequestParams), { checkoutVersion: CheckoutVersion.NEW }),
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.postSaferpayAlt = postSaferpayAlt;
const postSaferpayToken = (_a, _b) => tslib_1.__awaiter(void 0, [_a, _b], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { token, saveForFutureUse = false }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.postSaferpayToken, isServer);
    const axiosConfig = {
        method: 'POST',
        url,
        params: defaultRequestParams,
        withCredentials: true,
        data: {
            saferpayFieldsToken: token,
            saveForFutureUse: saveForFutureUse,
            checkoutVersion: CheckoutVersion.NEW,
        },
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.postSaferpayToken = postSaferpayToken;
const postOrderPaidByVoucher = (_a) => tslib_1.__awaiter(void 0, [_a], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams, }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.postOrderPaidByVoucher, isServer);
    const axiosConfig = {
        method: 'POST',
        url,
        params: defaultRequestParams,
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.postOrderPaidByVoucher = postOrderPaidByVoucher;
const postPayment = (_a, data_1) => tslib_1.__awaiter(void 0, [_a, data_1], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, data) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.postPayment, isServer);
    const axiosConfig = {
        method: 'POST',
        url,
        params: defaultRequestParams,
        data,
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.postPayment = postPayment;
const postPaymentProviderInput = (_a, provider_1) => tslib_1.__awaiter(void 0, [_a, provider_1], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, provider) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.postPaymentProviderInput, isServer, {
        provider: provider.toLowerCase(),
    });
    const axiosConfig = {
        method: 'POST',
        url,
        params: Object.assign(Object.assign({}, defaultRequestParams), { checkoutVersion: CheckoutVersion.NEW }),
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.postPaymentProviderInput = postPaymentProviderInput;
const postSubmitOrder = (_a, _b) => tslib_1.__awaiter(void 0, [_a, _b], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { provider, authorizationToken }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.postSubmitOrder, isServer, {
        provider: provider.toLowerCase(),
    });
    const axiosConfig = {
        method: 'POST',
        url,
        params: Object.assign(Object.assign({}, defaultRequestParams), { authorizationToken, checkoutVersion: CheckoutVersion.NEW }),
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.postSubmitOrder = postSubmitOrder;
const postSaferpayAlias = (_a, aliasId_1) => tslib_1.__awaiter(void 0, [_a, aliasId_1], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, aliasId) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.postSaferpayAlias, isServer);
    const axiosConfig = {
        method: 'POST',
        url,
        withCredentials: true,
        params: defaultRequestParams,
        data: { aliasId, checkoutVersion: CheckoutVersion.NEW },
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.postSaferpayAlias = postSaferpayAlias;
const postSubmitVoucher = (_a, _b) => tslib_1.__awaiter(void 0, [_a, _b], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { code, webcode }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.postSubmitVoucher, isServer);
    const axiosConfig = {
        method: 'POST',
        url,
        withCredentials: true,
        params: Object.assign(Object.assign(Object.assign({}, defaultRequestParams), { voucher: code }), (webcode && { controlCode: webcode })),
        data: { code, webcode },
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.postSubmitVoucher = postSubmitVoucher;
const postShoplandingPayment = (_a, shopNumber_1) => tslib_1.__awaiter(void 0, [_a, shopNumber_1], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, shopNumber) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, checkoutEndpoints.postShoplandingPayment, isServer);
    const axiosConfig = {
        method: 'POST',
        url,
        params: Object.assign(Object.assign({}, defaultRequestParams), { shopNumber, physicalShop: true }),
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.postShoplandingPayment = postShoplandingPayment;
//# sourceMappingURL=checkout.api.js.map